import type { MapMarker } from '../components/shared/map'
import type { Device } from '../types/domain'

export const DEVICES_SET_DATA = 'DEVICES_SET_DATA'
export const DEVICES_SET_MARKERS = 'DEVICES_SET_MARKERS'
export const DEVICES_SET_DEVICE_WRITER_DATA = 'DEVICES_SET_DEVICE_WRITER_DATA'
export const DEVICES_SET_SERVICE_HISTORY = 'DEVICES_SET_SERVICE_HISTORY'

export interface DevicesState {
    data: Device[]
    deviceWriter: unknown[]
    deviceServiceHistory: unknown[]
    markers: MapMarker[]
}

interface SetDataAction {
    type: typeof DEVICES_SET_DATA
    data: Device[]
}

interface SetMarkersAction {
    type: typeof DEVICES_SET_MARKERS
    data: MapMarker[]
}

interface SetDeviceWriterDataAction {
    type: typeof DEVICES_SET_DEVICE_WRITER_DATA
    data: unknown[]
}

interface SetServiceHistoryAction {
    type: typeof DEVICES_SET_SERVICE_HISTORY
    data: unknown[]
}

type DevicesAction =
    | SetDataAction
    | SetMarkersAction
    | SetDeviceWriterDataAction
    | SetServiceHistoryAction

/**
 * Set data into store
 */
function setData(state: DevicesState, data: Device[]): DevicesState {
    return {
        ...state,
        data: data,
    }
}

/**
 * Set device writer data into store
 */
function setDeviceWriterData(state: DevicesState, data: unknown[]): DevicesState {
    return {
        ...state,
        deviceWriter: data,
    }
}

/**
 * Set device markers into store
 */
function setDeviceMarkers(state: DevicesState, data: MapMarker[]): DevicesState {
    return {
        ...state,
        markers: data,
    }
}

/**
 * Set device service history into store
 */
function setDeviceServiceHistory(state: DevicesState, data: unknown[]): DevicesState {
    return {
        ...state,
        deviceServiceHistory: data,
    }
}

/**
 * Reducer for devices in store
 */
export default function reducer(
    state: DevicesState = [] as unknown as DevicesState,
    action: DevicesAction,
): DevicesState {
    switch (action.type) {
        case DEVICES_SET_DATA: return setData(state, action.data)
        case DEVICES_SET_DEVICE_WRITER_DATA: return setDeviceWriterData(state, action.data)
        case DEVICES_SET_MARKERS: return setDeviceMarkers(state, action.data)
        case DEVICES_SET_SERVICE_HISTORY: return setDeviceServiceHistory(state, action.data)
        default: return state
    }
}
